module.exports = __webpack_public_path__ + "8c493f2ed1cbeefda12986b2c23eb817.MP3";